// extracted by mini-css-extract-plugin
export default {"icon":"XDmLjOEER1W6Dt2N4hUj"};